import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getLoyaltyRewardList(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.LOYALTY_REWARD.LIST, action.payload, true);
}

export function* getLoyaltyRewardDetails(action: any): any {
    // The API expects integer ID, so we need to decode the base64 ID from the payload
    const decodedId = action.payload ? atob(action.payload) : action.payload;
    yield call(sagaFunction, action, CallApi.GET, `${APIS.LOYALTY_REWARD.DETAILS}/${decodedId}`, null, true);
}

export function* insertUpdateLoyaltyReward(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOYALTY_REWARD.INSERT_UPDATE, action.payload, true);
}

export function* deleteLoyaltyReward(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOYALTY_REWARD.DELETE, action.payload, true);
}